import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () => (
  <div className="page-content">
    <h1>404 - Seite nicht gefunden!</h1>
    <Link to="/">Zurück zur Homepage</Link>
  </div>
);
